export default __webpack_public_path__ + "media/AccessToTools.a47977dd.svg";